import React, { useState, useEffect, useRef } from 'react';
import * as d3 from "d3";
import { checkValue, formatValue } from '../utils/NumberUtils';
import { useHistory } from 'react-router-dom';
const SoldDailyGraph = (current) => {

    const [label] = useState([1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1])
    // const filteredData = current && current.daily && current.daily !== null && Object.keys(current.daily).length !== 0 ? current.daily.trans_power.filter(data => typeof data === 'number') : [0, 0];
    const data = current && current.daily && current.daily !== null && Object.keys(current.daily).length !== 0 ? checkValue(current.daily.trans_power) : [0, 0];
    const maxData = current.max;
    const topValue = current && current.current && current.current.mmr && current.current.mmr.real_power !== null ? current.current.mmr.real_power < 0 ? formatValue(current.current.mmr.real_power) : 0 : "---";
    const history = useHistory();
    const pathname = history["location"].pathname
    const schoolId = Number(pathname.split('/').pop());

    const svgRef = useRef();

    useEffect(() => {
        const width = 155;
        const height = 45;

        const svg = d3.select(svgRef.current)
            .attr('width', width)
            .attr('height', height)
            .attr('transform', 'translate(20,0)')
            .style('overflow', 'visible')
            .style('color', '#fff')
            .style('font', '12px Inter')
            .style('font-weight', 'normal')
            .style('margin-top', '40px')
            .style('margin-left', '-25px')

        svg.selectAll("*").remove();


        const xScale = d3.scaleBand()
            .domain(label.map((val, i) => i))
            .range([0, width])
            .padding(0.2);

        const yScale = d3.scaleLinear()
            .domain([0, maxData ? maxData : 30000])
            .range([height, 0]);


        const yAxis = d3.axisRight(yScale)
        // .ticks(5)
        // .tickSize(-width);


        svg.selectAll('.bar')
            .data(label)
            .join('line')
            .call(drawLineBar);

        svg.selectAll('.bar')
            .data(data && data.length !== 0 ? data : 0)
            .join('line')
            .call(drawLineBar2);

        svg.append("text")
            .text("今日")
            .attr("x", 0)
            .attr("y", 60)
            .style('fill', '#4947e0')
            .style('font', '14px Inter')
            .style('font-weight', '400');

        svg.append("text")
            .text(maxData ? `${((maxData / 1000).toFixed(0))}kWh` : '10kWh')
            .attr("x", 152)
            .attr("y", 7)
            .style('fill', '#4947e0')
            .style('font', '10px Inter')
        // .style('font-weight', 'bold');

        svg.append("text")
            .text("0kWh")
            .attr("x", 152)
            .attr("y", 45)
            .style('fill', '#4947e0')
            .style('font', '10px Inter')
        // .style('font-weight', 'bold');

        svg.append("text")
            .text("売電量")
            .attr("x", 0)
            .attr("y", -58)
            .style('fill', '#4947e0')
            .style('font', '16px Inter')
            .style('font-weight', 'normal');
        // .style('cursor', 'pointer')
        // .on("click", function () {
        //     history.push('/home/graph')
        // });
        svg.append("svg:image")
            .attr('xlink:href', '/img/sold_arrow.png')
            .attr('x', 52)
            .attr('y', -74)
            .attr('width', 10.38)
            .attr('height', 20.42)
            .style('cursor', 'pointer')
            .on("click", function () {
                history.push(`/home/graph/${schoolId}`)
            });

        svg.append('svg:image')
            .attr('xlink:href', '/img/arrow_down.png')
            .attr('x', 0)
            .attr('y', -35)
            .attr('width', 40)
            .attr('height', 25)

        svg.append("text")
            .text(`${topValue}kW`)
            .attr("x", 40)
            .attr("y", -11)
            .style('fill', '#4947e0')
            // .style('font-weight', 'bold')
            .style('font', '36px Inter');
        <p className="purchase-circle-arrow"></p>


        function drawLineBar(g) {
            //customize label color 
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))


                // .attr('y2', (val) => height)
                // .attr('stroke-dasharray', 1.5)
                .style('stroke', '#b4b2b2')
                .style('stroke-width', '4');
        }
        function drawLineBar2(g) {
            //customize color based on data
            g.call(yAxis)
                .attr('x1', (v, i) => xScale(i))
                .attr('y1', (val) => yScale(val))
                .attr('x2', (v, i) => xScale(i))
                .attr('y2', (val) => height)
                .style('stroke', '#4947e0')
                .style('stroke-width', '3')
        }
        // eslint-disable-next-line
    }, [data]);


    return (
        <svg ref={svgRef} id="weathergraph" />
    )
}
export default SoldDailyGraph;